import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/binity-logo--white.svg'


const _withScopeId = n => (_pushScopeId("data-v-3d8bf154"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  })
], -1))
const _hoisted_3 = { class: "login__headline" }
const _hoisted_4 = { class: "form-element__wrapper" }
const _hoisted_5 = {
  class: "form-label",
  for: "email"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "form-element__wrapper" }
const _hoisted_8 = {
  class: "form-label",
  for: "password"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "external-login"
}
const _hoisted_12 = { class: "divider" }
const _hoisted_13 = { class: "divider-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.sT('welcome')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.sT('email')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        required: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        type: "email",
        id: "email",
        placeholder: _ctx.sT('emailPlaceholder')
      }, null, 8, _hoisted_6), [
        [_vModelText, _ctx.email]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.sT('password')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        required: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        type: "password",
        id: "password",
        placeholder: _ctx.sT('passwordPlaceholder')
      }, null, 8, _hoisted_9), [
        [_vModelText, _ctx.password]
      ])
    ]),
    _createElementVNode("button", {
      class: "form-submit",
      disabled: _ctx.loading,
      type: "button",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sessionLogin && _ctx.sessionLogin(...args)))
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.sT('login')), 1)
          ], 64))
    ], 8, _hoisted_10),
    (_ctx.adEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.sT('or')), 1)
          ]),
          _createElementVNode("button", {
            class: "form-submit login-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.adLogin && _ctx.adLogin(...args)))
          }, _toDisplayString(_ctx.sT('adLogin')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}